import React, {useEffect} from 'react';
import NavigationMenuSection from "../../menu/menu-items/section/section";
import NavigationSection from "../../../core/model2/navigation/navigation-section";
import {GroupedData} from "../../../core/data-structures/group";
import MenuSearch_NoResults from "./no-results";
import {EntityType} from "../../../core/gd/const/item";
import MenuSearch_TaskResult from "./components/task-result";
import NavigationMenuItemProject from "../../menu/menu-items/project/menu-item-project";
import MenuSearch_PinResult from "./components/pin-result";
import NavigationMenuProjectsViewsItem from "../../menu/sections/projects/views/view-item";
import {SpaceProto} from "../../../core/model2/space/space-proto";
import MenuSearch_HomeViewResult from "./components/home-view-result";
import {NavigationSectionType} from "../../../core/model2/navigation/@const";
import MenuSearch_Loading from "./searching";

type Props = {
    space               : SpaceProto
    searchResult        : Promise<GroupedData>
    navigationSection?  : NavigationSection
    noResultsMessage?   : string
}

export default function MenuSearch_Results(props: Props) {

    const [searchResult, setSearchResult] = React.useState<GroupedData>([]);
    const [isLoaded, setIsLoaded] = React.useState<boolean>(false)

    useEffect(()=>{
        props.searchResult.then((result)=>{
            setSearchResult(result)
            setIsLoaded(true)
        }).catch(()=>{
            setSearchResult([])
            setIsLoaded(true)
        })
    }, [props.searchResult])

    if (!isLoaded) {
        return (
            <MenuSearch_Loading />
        )
    }

    if (_.isEmpty(searchResult)) {
        return <MenuSearch_NoResults/>
    }

    return (

        <>
            {searchResult.map((result, key) => {
                return <NavigationMenuSection key           = {key}
                                              name          = {result.label}
                                              collapsible   = {true}
                                              counter       = {result.items?.length}
                                              isOpen        = {true}>

                    {_.map(result.items, (menuItem) => {

                        switch (menuItem.type) {
                            case EntityType.TASK:
                                return <MenuSearch_TaskResult key       = {menuItem.id}
                                                              menuItem  = {menuItem}/>

                            case EntityType.PROJECT:
                                return <NavigationMenuItemProject key           = {menuItem.id}
                                                                  project       = {menuItem.project}
                                                                  isSelected    = {false}
                                                                  hideArrow     = {true}
                                                                  isExpanded    = {false}
                                                                  level         = {0}
                                                                  colorized     = {props.space.projectsColorize}/>

                            case EntityType.PIN:
                                return <MenuSearch_PinResult key        = {menuItem.id}
                                                             menuItem   = {menuItem}/>

                            case EntityType.PORTFOLIO:
                            default:

                                switch(props.space.navigation.type) {
                                    case NavigationSectionType.HOME:
                                    case NavigationSectionType.PROJECTS:

                                        return <MenuSearch_HomeViewResult key       = {menuItem.id}
                                                                          menuItem  = {menuItem}/>

                                    default:

                                        return <NavigationMenuProjectsViewsItem key     = {menuItem.id}
                                                                                item    = {menuItem.view}/>
                                }
                        }
                    })}
                </NavigationMenuSection>
            })}
        </>
    );
}
